import React from "react";
import { motion } from "framer-motion";

// Full-viewport ambient motion. Sits at z-0; nav/main use translucent surfaces so
// these fields remain visible across the page (not just peeking at the header edge).
const AmbientBackground = () => {
  const prefersReducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReducedMotion) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
      aria-hidden="true"
    >
      <motion.div
        className="absolute -top-20 -left-20 h-[36rem] w-[36rem] rounded-full bg-brand-gold/30 blur-3xl dark:bg-brand-gold/20"
        animate={{
          x: [0, 60, -30, 0],
          y: [0, 40, -20, 0],
          scale: [1, 1.1, 0.95, 1],
        }}
        transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-[20%] -right-24 h-[40rem] w-[40rem] rounded-full bg-brand-purple/25 blur-3xl dark:bg-brand-purple/15"
        animate={{
          x: [0, -70, 30, 0],
          y: [0, -50, 40, 0],
          scale: [1, 0.92, 1.08, 1],
        }}
        transition={{ duration: 32, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-[-10%] left-[15%] h-[34rem] w-[34rem] rounded-full bg-brand-cream/40 blur-3xl dark:bg-brand-cream/10"
        animate={{
          x: [0, 40, -40, 0],
          y: [0, -30, 35, 0],
          scale: [1, 1.06, 0.97, 1],
        }}
        transition={{ duration: 28, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default AmbientBackground;
